import { GET_POLICY_ADJUSTMENTS } from '../../constants/actions/policy';

export function getPolicyAdjustments(payload) {
    return {
        type: GET_POLICY_ADJUSTMENTS,
        payload,
    };
}
